import React from 'react';
import { QuickAccess } from '../../types/QuickAccess';
import { TableColumn } from '../../utils/tableUtils';
import { StatusBadge } from '../shared/AdminTable';
import { Edit, Trash2, ExternalLink } from 'lucide-react';

// Define quick access table columns
export const quickAccessColumns: TableColumn<QuickAccess>[] = [
  {
    id: 'title',
    label: 'Title',
    accessor: (item) => item.title,
    sortable: true,
  },
  {
    id: 'url',
    label: 'URL',
    accessor: (item) => (
      <div className="flex items-center space-x-2">
        <span className="max-w-xs truncate" title={item.url}>
          {item.url}
        </span>
        <a
          href={item.url}
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 hover:text-blue-800"
        >
          <ExternalLink size={16} />
        </a>
      </div>
    ),
    sortable: true,
  },
  {
    id: 'displayOrder',
    label: 'Order',
    accessor: (item) => item.displayOrder,
    sortable: true,
  },
  {
    id: 'active',
    label: 'Status',
    accessor: (item) => (
      <StatusBadge
        status={item.active ? 'active' : 'inactive'}
        type="status"
      />
    ),
    sortable: true,
  },
  {
    id: 'createdAt',
    label: 'Created',
    accessor: (item) => item.createdAt ? new Date(item.createdAt).toLocaleDateString() : '-',
    sortable: true,
  },
  {
    id: 'actions',
    label: 'Actions',
    accessor: () => null, // Actions are handled by the AdminTable component
    sortable: false,
  }
];

// Table configuration for QuickAccess management
export const quickAccessTableConfig = {
  entityName: 'QuickAccess',
  apiEndpoint: '/api/admin/quick-access',
  columns: quickAccessColumns,
  searchFields: ['title', 'url'] as (keyof QuickAccess)[],
  filterOptions: {
    active: [
      { value: 'active', label: 'Active' },
      { value: 'inactive', label: 'Inactive' }
    ]
  },
  defaultSort: { column: 'displayOrder', direction: 'asc' as const },
  itemsPerPageOptions: [10, 25, 50, 100],
  defaultItemsPerPage: 25,
  exportFileName: 'quick-access-items',
  defaultVisibleColumns: {
    title: true,
    url: true,
    displayOrder: true,
    active: true,
    createdAt: true,
    actions: true
  }
};
